import noSearchIcon from "../../../assets/no-search-found.svg";

export const headerData = [
  {
    text: "Title",
  },
  {
    text: "Status",
  },
];

export const footerData = {
  title: "No promo yet",
  subTtitle: "Try the blue button on the top right and add a few!",
  imgSrc: noSearchIcon,
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "title",
    type: "",
  },
  {
    key: "enabled",
    type: "",
  },
];

export const promoProductBodyDataAndKeyTypes = [
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
  {
    key: "itemAvailable",
    type: "",
    prepend: "",
  },
];

export const promoBasketProductBodyDataAndKeyTypes = [
  {
    key: "isChecked",
    type: "checkbox",
    prepend: "",
  },
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
];

export const promoProductFooterData = {
  title: "No record found",
  subTtitle: "No such order exists. Create one?",
  imgSrc: noSearchIcon,
  alt: "no search found",
};
